import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { IProduto } from "../../model";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";
import { toast } from "react-toastify";

class _ProdutoStore {
  obs = observable({
    produtos: [] as IProduto[],
    produtosMap: [] as IProduto[],
    filter: "" as string,
    produtos_length: 0,
    loading: false,
    selectedTab: "entrada"
  })

  async load(page: number, filter: string, entrada_saida: string, estado: string) {


    let data = {
      page: page,
      limit: 50,
      filter: filter.replace(/\./g, ""),
      entrada_saida: entrada_saida,
      estado: estado
    }

    let resp = await api.post("/api/produtos-filter", data)

    if (resp.data.itens.length > 0) {

      return resp.data.itens

    }

    return []

  }

  async get(id: string) {

    let resp = await api.get(`/api/produtos/${id}`)

    return resp.data

  }

  async loadProdutos(page: number, filter: string, entrada_saida: string, estado: string) {

    let data = {
      page: page,
      limit: 50,
      filter: filter.replace(/\./g, ""),
      entrada_saida: entrada_saida,
      estado: estado
    }

    let resp = await api.post("/api/produtos-filter", data)

    this.obs.produtos = []

    this.obs.produtos_length = 0

    if (resp.data.itens.length > 0) {

      this.obs.produtos = resp.data.itens;

      this.obs.produtos_length = resp.data.count

    }

  }

  async handleDelete(produto: IProduto) {

    try {

      let resp = await api_adm.post(`/api/admin/produtos/delete`, produto);

      if (resp.data.ok) {

        toast.success(`Produto excluído: ${produto.descricao}`, {});
        return true

      } else {

        toast.error(`Erro excluindo produto: ${resp.data.msg}`, {});
      }

    } catch (ex) {

      toast.error(`Erro ao excluir Produto!`, {});

    }

    return false


  }

  async handleExport(entrada_saida: string, estado: string) {

    try {

      let data = {
        entrada_saida: entrada_saida,
        estado: estado
      }

      let resp = await api.post(`/api/produtos/export/excel`, data);

      if (resp.data.ok) {
        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_produtos.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {
        toast.warning(resp.data.error, {});
      }

    } catch (ex) {

      toast.warning('Erro ao exportar, tente novamente mais tarde.', {});

    }

  }

  async loadCalcProdutos(page: number, calc_id: string, filter: string, estado: string) {

    try {

      this.obs.loading = true

      let data = {
        calc_id: calc_id,
        page: page,
        limit: 20,
        text: filter.replace(/\./g, ""),
        estado: estado
      }

      let resp = await api_adm.post('/api/admin/calc/produtos', data);

      this.obs.loading = false

      return resp.data.produtos

    } catch (ex) { }

    this.obs.loading = false

    return []

  }

  async handleDeleteProduto(produto_id: string, calc_id: string, estado: string) {

    try {

      let data = {
        calc_id: calc_id,
        produto_id: produto_id,
        estado: estado
      }

      let resp = await api_adm.post('/api/admin/calc/produtos/delete', data);

      if (resp.data.ok) {

        return true

      }

    } catch (ex) { }

    return false

  }


  async handleAddProduto(produto_id: string, calc_id: string, estado: string) {

    try {

      let data = {
        calc_id: calc_id,
        produto_id: produto_id,
        estado: estado
      }

      let resp = await api_adm.post('/api/admin/calc/produtos/add', data);

      if (resp.data.ok) {

        return true

      }

    } catch (ex) { }

    return false

  }

  async handleImport(data) {

    let resp = await api_adm.post("/api/admin/produtos/import/excel", data)

    if (resp.data.ok) {

      toast.success('Arquivo importado com sucesso!', {});

      return true

    }

    toast.error(resp.data.error, {});

    return false

  }

}

export const ProdutoStore = new _ProdutoStore();
